import Hero from "@/components/home/Hero";
import EditorialMarquee from "@/components/home/EditorialMarquee";
import RiquetSection from "@/components/home/RiquetSection";
import Manifesto from "@/components/home/Manifesto";
import SitesSection from "@/components/home/SitesSection";
import AffichesGallery from "@/components/home/AffichesGallery";
import ArtistsPreview from "@/components/home/ArtistsPreview";
import ParcoursMap from "@/components/home/ParcoursMap";
import Timeline from "@/components/home/Timeline";
import Editions2025 from "@/components/home/Editions2025";
import Partners from "@/components/home/Partners";
import TeamCarousel from "@/components/home/TeamCarousel";
import LegalStrip from "@/components/home/LegalStrip";
import Newsletter from "@/components/home/Newsletter";
import PageSEO from "@/components/PageSEO";

export default function Home() {
  return (
    <main data-testid="home-page">
      <PageSEO
        title="Canal'Art 2026 — 30 ans UNESCO"
        description="Le plus grand parcours artistique à ciel ouvert du monde : 750 km d'art le long du Canal des 2 mers. Découvrez les artistes qui célèbrent les 30 ans d'inscription UNESCO du Canal du Midi."
        image="https://customer-assets-m6fa6gv7.emergentagent.net/job_midi-gallery/artifacts/fwibbexq_do%20you%20have%20time%20to%20dream.jpg"
        imageAlt="Do you have time to dream? — Carlota '95 · œuvre du Fil du Midi"
        path="/"
      />
      <Hero />
      <EditorialMarquee />
      <Manifesto />
      <RiquetSection />
      <SitesSection />
      <AffichesGallery />
      <ParcoursMap />
      <ArtistsPreview />
      <Editions2025 />
      <Timeline />
      <Partners />
      <TeamCarousel />
      <LegalStrip />
      <Newsletter />
    </main>
  );
}
